import { FirebaseDocRefType, FirebaseTimestamp, FirebaseTimestampType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { StoreCustomerType } from 'types/storeCustomer'

const storeCustomerConverter = getConverter<StoreCustomerType>()

export const fetchStoreCustomer = (
  storeRef: FirebaseDocRefType,
  userId: string
): Promise<StoreCustomerType | undefined> => {
  return storeRef
    .collection('store_customers')
    .doc(userId)
    .withConverter(storeCustomerConverter)
    .get()
    .then((snapshot) => {
      return snapshot.data()
    })
}

export const fetchStoreCustomers = (storeRef: FirebaseDocRefType): Promise<StoreCustomerType[]> => {
  return storeRef
    .collection('store_customers')
    .withConverter(storeCustomerConverter)
    .get()
    .then((snapshots) => snapshots.docs.map((snapshot) => snapshot.data()))
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const fetchFavoriteStoreCustomers = (storeRef: FirebaseDocRefType): Promise<StoreCustomerType[]> => {
  return storeRef
    .collection('store_customers')
    .withConverter(storeCustomerConverter)
    .where('is_favorite', '==', true)
    .get()
    .then((snapshots) => snapshots.docs.map((snapshot) => snapshot.data()))
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const updateStoreCustomerNotes = ({
  storeRef,
  userId,
  notes,
}: {
  storeRef: FirebaseDocRefType
  userId: string
  notes: StoreCustomerType['notes']
}): Promise<void | Error> => {
  const updateData: Pick<StoreCustomerType, 'notes' | 'updated_at'> = {
    notes,
    updated_at: FirebaseTimestamp.now(),
  }
  return storeRef
    .collection('store_customers')
    .doc(userId)
    .update(updateData)
    .catch((e) => {
      console.error(e)
      return new Error("Couldn't update store customer notes.")
    })
}
